<template>    
  <div class="textarea">
    <label :for="name">{{ $t(label) }}</label><span v-if="hasError && error" class="badge-error" variant="none" :id="`${name}-error`">
      <small>{{ error }}</small>
    </span>
    <textarea
      rows="6" cols="50"
      v-bind="$attrs"
      :class="{
        'error': hasError,
        'green': !!value && !hasError
      }"
      :aria-describedby="`${name}-error`"
      :value="value"
      :placeholder="$t(tooltip)"
      :name="name"
      :id="name"
      v-on="{
        ...$listeners,
        input: event => $emit('input', event.target.value)
      }"
    ></textarea>
    <!-- <p :id="`${name}-error`" class="error" v-if="hasError && error">{{ error }}</p> -->
  </div>

</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number]
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      required: false
    },
    error: {
      type: String,
      required: false
    },
    hasError: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
textarea {
  /* width: 100%; */
  /* padding: 0.375rem 0.75rem; */
  /* font-size: 1rem; */
  /* line-height: 1.5; */
  /* color: #495057; */
  /* background-color: #fff; */
  /* background-clip: padding-box; */
  /* border: 1px solid #ced4da; */
  /* border-radius: 0.25rem; */
  /* transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; */
}
textarea {
  resize: vertical;
  border-radius: 25px;
  /* height: 55px; */
  line-height: 1.15;
  font-size: 16px;
  border: none;
  /* padding: 0 15px; */
  padding: 20px;
  box-sizing: border-box;
  color: #696A87;
  background: #f8f8f8;
  margin-bottom: 10px;
}
.textarea {
  margin-top: 25px;
}
@media screen and (max-width: 479px) {
 textarea {
    width: 85%;
  }
}
textarea.error {
  border-color: #721c24;
  border-width: 3px;
}
p.error {
  color: #721c24;
}

textarea.green {
  border-color: green;
  border-width: 2px;
}
</style>
